import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { TopNav } from './TopNav';
import { NavigationBar } from './NavigationBar';
import { useUiStore } from '@/store/ui.store';
import { useIsMobile } from '@/hooks/useMediaQuery';
import { cn } from '@/lib/utils/cn';

export const AppLayout = () => {
  const isMobile = useIsMobile();
  const sidebarOpen = useUiStore((state) => state.sidebarOpen);
  const setIsMobile = useUiStore((state) => state.setIsMobile);
  const setSidebarOpen = useUiStore((state) => state.setSidebarOpen);
  const [_sidebarExpanded, setSidebarExpanded] = useState(false);

  useEffect(() => {
    setIsMobile(isMobile);
  }, [isMobile, setIsMobile]);

  const handleCloseSidebar = () => {
    setSidebarOpen(false);
  };

  const handleSidebarExpandChange = (expanded: boolean) => {
    setSidebarExpanded(expanded);
  };

  return (
    <div className="h-screen overflow-hidden bg-background" style={{ ['--topnav-height' as any]: '68px' }}>
      {/* Navigation Bar - Responsive for both mobile and desktop */}
      <NavigationBar 
        isOpen={isMobile ? sidebarOpen : true}
        onClose={handleCloseSidebar}
        onExpandChange={handleSidebarExpandChange}
      />
      
      {/* Top Navigation Bar - All screen sizes */}
      <TopNav />
      
      {/* Main Content */}
      <main className={cn(
        'h-screen overflow-y-auto transition-all duration-500 ease-in-out pt-(--topnav-height)',
        !isMobile ? 'ml-[60px]' : ''
      )}>
        <Outlet />
      </main>
    </div>
  );
};

